<template>
  <div class="container bright-background integrations">
    <div class="integrations__header">
      <button class="integrations__button"
              :class="{'integrations__button_disabled': !isIntegrationsAvailable }"
              @click="openIntegrationModal"
              v-if="!isCurrentUserClientCollaborator">
        ADD NEW INTEGRATION
      </button>
    </div>
    <div class="integrations__body">
      <div class="common-table">
        <div class="common-table__row common-table__header">
          <div class="common-table__header-cell"
               v-for="column in tableConfig"
               :key="column.propName"
               :class="[
                 `integrations__table__${column.propName}`,
                 { 'common-table__header-cell_sortable': column.isSortable }
               ]"
               @click.exact="onHeaderCellClicked(column)"
               @click.shift="onHeaderCellClickedWithShift(column)">
            <base-table-sortable-column
              v-if="column.isSortable"
              :label="column.label"
              :prop-name="column.propName"
              :sort-config="sortConfig"/>
            <template v-else>{{column.label}}</template>
          </div>
        </div>
        <template v-if="integrationsList.length">
          <div class="common-table__row"
               v-for="item in integrationsList.filter(i => i.service === 'Asana')"
               @click="openIntegrationChange(item.service)"
               :key="item.service">
            <div class="common-table__cell"
                 v-for="column in tableConfig"
                 :key="column.propName"
                 :class="[`integrations__table__${column.propName}`]">
            <span v-if="column.propName === 'service'"
                  class="common-table__first-column">
                {{item[column.propName]}}
              </span>
              <template v-else-if="column.propName === 'last_sync'">
                {{mapLastSync(item[column.propName])}}
              </template>
              <template v-else-if="column.propName === 'is_error'">
                <base-material-design-icon v-if="item[column.propName]"
                                           @click.stop="openErrorMessagePopup"
                                           icon="alert"
                                           class="integrations__alert-icon"/>
              </template>
              <template v-else>
                {{item[column.propName]}}
              </template>
            </div>
          </div>
        </template>
        <div v-else class="common-table__no-data">{{ noDataLabel }}</div>
      </div>
    </div>
    <div class="integrations__body integrations__body__cloudflare">
      <div class="common-table">
        <div class="common-table__row common-table__header">
          <div class="common-table__header-cell"
               v-for="column in cloudflareTableConfig"
               :key="column.propName"
               :class="[
                 `integrations__table__${column.propName}`,
                 { 'common-table__header-cell_sortable': column.isSortable }
               ]"
               @click.exact="onHeaderCellClicked(column)"
               @click.shift="onHeaderCellClickedWithShift(column)">
            <base-table-sortable-column
              v-if="column.isSortable"
              :label="column.label"
              :prop-name="column.propName"
              :sort-config="sortConfig"/>
            <template v-else>{{column.label}}</template>
          </div>
        </div>
        <template v-if="integrationsList.length">
          <div class="common-table__row"
               v-for="item in integrationsList.filter(i => i.service === 'cloudflare')"
               @click="openIntegrationChange(item.service)"
               :key="item.service">
            <div class="common-table__cell"
                 v-for="column in cloudflareTableConfig"
                 :key="column.propName"
                 :class="[`integrations__table__${column.propName}`]">
            <span v-if="column.propName === 'service'"
                  class="common-table__first-column">
                {{item[column.propName]}}
              </span>
              <template v-else-if="column.propName === 'last_sync'">
                {{mapLastSync(item[column.propName])}}
              </template>
              <template v-else-if="column.propName === 'is_error'">
                <base-material-design-icon v-if="item[column.propName]"
                                           @click.stop="openErrorMessagePopup"
                                           icon="alert"
                                           class="integrations__alert-icon"/>
              </template>
              <template v-else-if="column.propName === 'api_key' || column.propName === 'account_id'">
                {{ showMaskedValue(item[column.propName]) }}
              </template>
              <template v-else>
                {{item[column.propName]}}
              </template>
            </div>
          </div>
        </template>
        <div v-else class="common-table__no-data">{{ noDataLabel }}</div>
      </div>
    </div>
    <div class="integrations__body integrations__body__shopify">
      <div class="common-table">
        <div class="common-table__row common-table__header">
          <div class="common-table__header-cell"
               v-for="column in shopifyTableConfig"
               :key="column.propName"
               :class="[
                 `integrations__table__${column.propName}`,
                 { 'common-table__header-cell_sortable': column.isSortable }
               ]"
               @click.exact="onHeaderCellClicked(column)"
               @click.shift="onHeaderCellClickedWithShift(column)">
            <base-table-sortable-column
              v-if="column.isSortable"
              :label="column.label"
              :prop-name="column.propName"
              :sort-config="sortConfig"/>
            <template v-else>{{column.label}}</template>
          </div>
        </div>
        <template v-if="integrationsList.length">
          <div class="common-table__row"
               v-for="item in integrationsList.filter(i => i.service === 'shopify')"
               @click="openIntegrationChange(item.service)"
               :key="item.service">
            <div class="common-table__cell"
                 v-for="column in shopifyTableConfig"
                 :key="column.propName"
                 :class="[`integrations__table__${column.propName}`]">
            <span v-if="column.propName === 'service'"
                  class="common-table__first-column">
                {{item[column.propName]}}
              </span>
              <template v-else-if="column.propName === 'is_error'">
                <base-material-design-icon v-if="item[column.propName]"
                                           @click.stop="openErrorMessagePopup"
                                           icon="alert"
                                           class="integrations__alert-icon"/>
              </template>
              <template v-else-if="column.propName === 'access_token'">
                {{ showMaskedValue(item[column.propName]) }}
              </template>
              <template v-else>
                {{item[column.propName]}}
              </template>
            </div>
          </div>
        </template>
        <div v-else class="common-table__no-data">{{ noDataLabel }}</div>
      </div>
    </div>
    <modal name="integrationsSelect"
           v-bind="modalProps">
      <AddNewIntegration :availableIntegrations="availableIntegrations"
                         :integrationLinks="integrationLinks"
                         @cloudflare="addCloudflareIntegration($event)"
                         @shopify="addShopifyIntegration($event)"
                         @close="closeIntegrationModal" />
    </modal>
    <modal name="integrationsChange"
           v-bind="modalProps">
      <base-integration-menu :type="type"
                             :currentClientId="currentClientId"
                             :changeAccountLink="integrationLinks[type]"
                             :mode="integrationMenuMode"
                             @close="closeIntegrationChange" />
    </modal>
    <modal name="errorMessagePopup"
           v-bind="modalProps">
      <ErrorMessagePopup @close="closeErrorMessagePopup" />
    </modal>
    <div class="integrations__loader" v-if="isDataUpdating">
      <base-loader/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ToasterService from '@/services/toasterService'
import BaseSortMixins from '@/common/BaseSortMixins'
import AddNewIntegration from './AddNewIntegration'
import ErrorMessagePopup from './ErrorMessagePopup'
import baseModalProps from '@/common/BaseModalProps'
import helper from '@/services/Helper'
import moment from 'moment'

const tableConfig = [
  {
    label: 'Service',
    propName: 'service',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: '',
    propName: 'is_error',
    sortByLenght: false,
    isSortable: false
  },
  {
    label: 'Workspace',
    propName: 'workspace',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: 'Project',
    propName: 'project',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: 'Last Sync',
    propName: 'last_sync',
    sortByLenght: false,
    isSortable: true
  }
]
const cloudflareTableConfig = [
  {
    label: 'Service',
    propName: 'service',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: 'Email',
    propName: 'email',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: '',
    propName: 'is_error',
    sortByLenght: false,
    isSortable: false
  },
  {
    label: 'Account ID',
    propName: 'account_id',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: 'API Key',
    propName: 'api_key',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: 'Enabled',
    propName: 'enabled',
    sortByLenght: false,
    isSortable: true
  }
]
const shopifyTableConfig = [
  {
    label: 'Service',
    propName: 'service',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: '',
    propName: 'is_error',
    sortByLenght: false,
    isSortable: false
  },
  {
    label: 'Access Token',
    propName: 'access_token',
    sortByLenght: false,
    isSortable: true
  },
  {
    label: 'Enabled',
    propName: 'enabled',
    sortByLenght: false,
    isSortable: true
  }
]

export default {
  name: 'Integrations',
  components: { AddNewIntegration, ErrorMessagePopup },
  mixins: [BaseSortMixins],
  props: {
    integrationError: {
      type: String,
      default: ''
    },
    integrationStatus: {
      type: Object,
      default: () => ({})
    }
  },
  mounted () {
    const integrationStatus = this.integrationStatus
    if (integrationStatus.length) {
      try {
        const statusData = JSON.parse(integrationStatus)
        this.tempClientId = statusData.client_id
        this.type = statusData.type
        // TODO: move it to helper as a constants
        this.integrationMenuMode = 'update'
        this.$modal.show('integrationsChange')
      } catch (e) {
        console.log(e)
      } finally {
        // remove integration status from url
        this.$router.push(this.$route.path)
      }
    }
  },
  data () {
    return {
      sortConfig: [{
        sortDirection: helper.DIRECTION_ASC,
        propertyName: 'service'
      }],
      type: null,
      tempClientId: null,
      isDataLoaded: false,
      isDataUpdating: false,
      integrationLinks: null,
      integrationMenuMode: null,
      tableConfig,
      cloudflareTableConfig,
      shopifyTableConfig
    }
  },
  watch: {
    integrationError: {
      handler (value) {
        if (value) {
          ToasterService.showToast(ToasterService.ERROR_TYPE, value)
          // remove err from url
          this.$router.push(this.$route.path)
        }
      },
      immediate: true
    },
    clientId: {
      handler (value) {
        const redirectUrl = `${window.location.origin}/integrations/asana/oauth`
        const state = JSON.stringify({
          'client_id': value,
          'redirect_url': redirectUrl,
          'current_route': this.$route.fullPath
        })
        this.integrationLinks = {
          'asana': `https://app.asana.com/-/oauth_authorize?client_id=1170381332056778&redirect_uri=${redirectUrl}&response_type=code&state=${state}`
        }
        value && this.loadData()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      isNavbarCollapsed: 'isNavbarCollapsed'
    }),
    ...mapState('integrations', {
      isIntegrationsAvailable (state) {
        return state.availableIntegrations.length
      },
      integrationsList: 'integrationsList',
      availableIntegrations: 'availableIntegrations'
    }),
    currentClientId () {
      return this.clientId || this.tempClientId
    },
    modalProps () {
      const shareModalProps = {
        width: '610px'
      }
      return { ...baseModalProps, ...shareModalProps }
    },
    noDataLabel () {
      return this.isDataLoaded ? 'No integrations found' : 'Awaiting Data'
    }
  },
  methods: {
    ...mapActions('integrations', ['getIntegrationsList', 'createCloudflareIntegration', 'createShopifyIntegration']),
    async loadData () {
      this.isDataUpdating = true
      await this.getIntegrationsList({ clientId: this.clientId })
      this.isDataUpdating = false
      if (!this.isDataLoaded) {
        this.isDataLoaded = true
      }
    },
    async addShopifyIntegration (data) {
      data = { ...data, clientId: this.clientId }
      await this.createShopifyIntegration(data)
      this.loadData()
    },
    async addCloudflareIntegration (data) {
      data = { ...data, clientId: this.clientId }
      await this.createCloudflareIntegration(data)
      this.loadData()
    },
    showMaskedValue (val, cutoff = 5, repeat = 8) {
      return val ? val.slice(0, cutoff) + '\u2022'.repeat(repeat) : ''
    },
    openIntegrationModal () {
      this.$modal.show('integrationsSelect')
    },
    closeIntegrationModal () {
      this.$modal.hide('integrationsSelect')
    },
    openErrorMessagePopup () {
      this.$modal.show('errorMessagePopup')
    },
    closeErrorMessagePopup () {
      this.$modal.hide('errorMessagePopup')
    },
    openIntegrationChange (type) {
      this.type = type.toLowerCase()
      this.integrationMenuMode = 'change'
      this.$modal.show('integrationsChange')
    },
    closeIntegrationChange (update) {
      this.$modal.hide('integrationsChange')
      update && this.loadData()
    },
    mapLastSync (value) {
      return moment(value).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style scoped lang="scss">
  .integrations__body__shopify {
    margin-top: 15px;
  }
  .integrations__body__cloudflare {
    margin-top: 15px;
  }
  .common-table {
    &__header {
      background-color: rgba(1, 22, 39, 0.1);
    }

    &__first-column {
      color: $rfx-dark-march;
    }

    &__row {

      &:hover {
        cursor: pointer;
        background-color: rgba(1, 22, 39, 0.1);
      }
    }

    &__cell {

      &.keywords__serp_features {
        flex-basis: 115px;
      }
    }

    &__header-cell {
      color: $rfx-dark-march;
      font-weight: bold;

      &__wrapper {
        height: 100%;
        cursor: pointer;
      }

      &::v-deep .sort-column__label {
        font-size: 14px;
      }
    }

    &__no-data {
      font-size: 27px;
      font-weight: 600;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      color: $rfx-light-march;
      padding: 30px 0;
    }
  }

  .integrations {
    background-color: #fff;
    padding: 60px;
    position: relative;

    &__header {
      padding: 14px 0;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    &__button {
      width: 180px;
      padding: 0 20px;
      height: 50px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      border: none;
      outline: none;
      cursor: pointer;
      background-color: $rfx-dark-march;
      color: #fff;

      &_disabled {
        pointer-events: none;
        opacity: .5;
      }
    }

    &__alert-icon {
      color: red;
      position: absolute;
      font-size: 17px;
      margin-top: -1px;
      cursor: pointer;
    }

    &__table {

      &__is_error,
      &__service {
        flex: 1;
      }

      &__workspace,
      &__project,
      &__last_sync {
        flex: 2;
      }

    }

    &__loader {
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: 10;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(255, 255, 255, .7);
    }
  }
</style>
